// extracted by mini-css-extract-plugin
export default {"wrapper":"stumbleGuysAlternative_wrapper__GbaEd","button":"stumbleGuysAlternative_button__QWX7t"};